module.exports = __webpack_public_path__ + "static/media/quizz.64386d08.svg";